import React, { useState, useEffect } from "react";

const SelectTipologie = ({ data, onChange, selectedTipologia }) => {
  const [selectedValue, setSelectedValue] = useState(""); // Inizializza senza valore

  useEffect(() => {
    // Aggiorna selectedValue SOLO se selectedTipologia ha un valore
    if (selectedTipologia) {
      setSelectedValue(selectedTipologia);
    }
  }, [selectedTipologia]);

  const handleChange = (event) => {
    const value = event.target.value;
    const selectedCategoria = data.find(categoria =>
      categoria.tipologieEventi.some(evento => evento.code === value)
    );
    setSelectedValue(value);
    onChange(selectedCategoria, value); // Passa direttamente il valore
  };

  return (
    <div>
      <label htmlFor="tipologie">Seleziona una tipologia:</label>
      <select id="tipologie" value={selectedValue} onChange={handleChange}>
        <option value="" disabled>Seleziona...</option>
        {data.map((categoria) => (
          <optgroup key={categoria.tipologia} label={categoria.tipologia}>
            {categoria.tipologieEventi.map((evento) => (
              <option key={evento.code} value={evento.code}>
                {evento.descrizione}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
    </div>
  );
};

export default SelectTipologie;